<template>
  <nav :class="{ loading: loading, sticky: sticky }">
    <slot name="nav" />
    <ul id="form-nav">
      <li v-if="hasPrevious" class="cancel">
        <ButtonCircleIcon
          type="button"
          icon-name="previous"
          theme="secondary"
          :enable="hasPrevious && !loading"
          @click.prevent="handleClickPrevious"
        />
      </li>
      <li v-if="hasCancel">
        <FormButtonCancel
          type="button"
          :disabled="loading"
          @click.prevent="handleClickCancel"
        />
      </li>
      <li v-for="button in submitButtons" :key="button.id" class="submit">
        <FormButtonSubmit
          :disabled="!submitEnabled"
          :loading="loading && button.id === 'default'"
          type="submit"
          @click.prevent="(e) => handleClickSubmit(e, button.id)"
        >
          {{ button.label }}
        </FormButtonSubmit>
      </li>
      <slot />
    </ul>
  </nav>
</template>
<script lang="ts" setup>
interface Props {
  hasPrevious: boolean;
  hasCancel: boolean;
  sticky?: boolean;
  hasSubmit?: boolean;
  labelSubmit?: string;
  loading?: boolean;
}
const props = defineProps({
  hasPrevious: { type: Boolean },
  hasCancel: { type: Boolean, default: false },
  sticky: { type: Boolean, default: true },
  hasSubmit: { type: Boolean, default: true },
  labelSubmit: { default: 'Valider' },
  loading: { type: Boolean, default: false }
});

const dialog = useDialogStore();

const {
  formNavigation,
  formFieldsData: { edited },
  formFieldsValidation: { validated },
  error,
} = inject(INJECT_FORM_PAGE);

const { submitButtons } = formNavigation;

const submitEnabled = computed(() => {
  if (formNavigation.lockState.value > 0) {
    return formNavigation.lockState.value === 1;
  } else {
    return (
      validated.value &&
      edited.value &&
      !props.loading &&
      !error.value &&
      !dialog.isOpened
    );
  }
});

const handleClickPrevious = (e) => {
  formNavigation.triggerPrevious();
};

const handleClickCancel = () => {
  formNavigation.triggerCancel();
};

const handleClickSubmit = (e, id) => {
  formNavigation.triggerSubmit(id);
};
</script>
<style lang="scss" scoped>
nav {
  width: 100%;
  pointer-events: none;
  &.sticky {
    position: sticky;
    z-index: 1;
    bottom: 2rem;
    .offset-mobile-menu & {
      @include mobile {
        bottom: calc(var(--footer_height) + 2rem);
      }
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: var(--gap_n);
    list-style: none;
    @include above('l') {
      gap: var(--gap_l);
    }
  }
  li {
    pointer-events: auto;
  }
  &.loading {
    pointer-events: none;
  }
}
</style>
